export default __webpack_public_path__ + "static/media/location-white.8291b4dd.svg";